import type { JSX } from "preact";
import { Editor } from "slate";
import { ReactEditor, useSlate } from "slate-react";
import type { Icon } from "../components/icons";
import { ButtonIcon } from "./ButtonIcon";

type MarkButtonType =
    | "bold"
    | "italic"
    | "underline"
    | "strikethrough"
    | "code";

interface Parameters {
    type: MarkButtonType;
    icon: Icon;
}

export function MarkButton({ type, icon }: Parameters): JSX.Element {
    const editor = useSlate();
    return (
        <ButtonIcon
            active={isMarkActive(editor, type)}
            icon={icon}
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                toggleMark(editor, type);
            }}
        />
    );
}

function isMarkActive(editor: Editor, type: MarkButtonType): boolean {
    const marks = Editor.marks(editor);
    return marks?.[type] === true;
}

function toggleMark(editor: Editor, type: MarkButtonType): void {
    if (isMarkActive(editor, type)) {
        Editor.removeMark(editor, type);
    } else {
        Editor.addMark(editor, type, true);
    }

    // Return focus to editor
    ReactEditor.focus(editor);
}
